import { useDeleteDiscussion } from 'hb-react/frontoffice/apps/Forum/hooks/queries/useDeleteDiscussion';
import ConfirmationModal from 'hb-react/shared/components/DesignSystem/Modal/ConfirmationModal';

interface DeleteDiscussionModalProps {
  onCloseModal: () => void;
  title: string;
  discussionId: number;
}

const DeleteDiscussionModal = ({
  onCloseModal,
  title,
  discussionId,
}: DeleteDiscussionModalProps) => {
  const { isLoading, mutate } = useDeleteDiscussion(discussionId);

  const onConfirmation = async () => {
    await mutate();
    onCloseModal();
  };

  return (
    <ConfirmationModal
      isLoading={isLoading}
      onCloseModal={onCloseModal}
      confirmButtonLabel={s__('Forum|Delete')}
      onConfirmation={onConfirmation}
      text={s__(
        'Forum|You are about to delete %{title}. Are you sure you want to delete it?',
      ).i__({ title })}
    />
  );
};

export default DeleteDiscussionModal;
